import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalBaseComponent } from '../add-or-edit-org-modal/modal-base.component';
import { DataService } from '../data/data.service';
import { EEUReport } from '../data/eeu-report';

@Component({
  selector: 'app-eeu-report-modal',
  templateUrl: './eeu-report-modal.component.html',
  styleUrls: ['./eeu-report-modal.component.scss']
})
export class EeuReportModalComponent extends ModalBaseComponent<EEUReport> implements OnInit {

  @Input() orgID: number;

  // TODO: These methods aren't necessary, perhaps this should not extend ModalBaseComponent
  initializeNewData(): void {
    this.data = undefined;
    this.dataService.getEEUReport(this.orgID).subscribe(o => {
      this.data = o;
    })
    return;
  }
  isInputValid(): boolean {
    throw new Error('Method not implemented.');
  }
  saveEdit(): void {
    throw new Error('Method not implemented.');
  }
  saveNew(): void {
    throw new Error('Method not implemented.');
  }

  constructor(modalService: NgbModal, dataService: DataService) { super(modalService, dataService); }

  ngOnInit() {
  }

}
